import { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Tab, Tabs } from 'react-bootstrap';
import { getKiinteistoWhole } from '../api/api';
import PerustiedotTab from '../components/PerustiedotTab';
import DokumentitTab from '../components/DokumentitTab';
import PTSLongTermTable from '../components/PTS/PTSLongTermTable';
import PTSRoadmap from '../components/PTS/PTSRoadmap';
import CapexYhteenveto from '../components/PTS/CapexYhteenveto';
import ToimenpiteetTekstimuodossa from '../components/PTS/ToimenpiteetTekstimuodossa';
import config from '../devprodConfig';
import KiinteistoGallery from '../components/KiinteistoGallery';
import { KiinteistoRiskEditor } from '../components/report/KiinteistoRiskEditor';
import EnergiaKatselmusTab from '../components/report/EnergiaKatselmusTab';
import KuntotutkimuksetTab from '../components/KuntotutkimuksetTab';
import RTKayttoikaKysely from '../components/report/rtKayttoika/RTKayttoikaKysely';
import MaaraaikaistarkastusTaulukko from '../components/MaaraaikaistarkastusTaulukko';
import RakennuslupaTaulukko from '../components/RakennuslupaTaulukko';
import { useRakennusData } from '../context/RakennusDataContext';
import useEnsureEnergiaTable from "../components/hooks/useEnsureEnergiaTable";
import { useImageHandler } from '../components/utils/ImageHandler';
import { recordVisit } from '../components/utils/recentlyVisited';
import useDocumentTitle from '../components/hooks/useDocumentTitle';

const TAB_LABELS = {
  perustiedot: 'Perustiedot',
  raportit: 'Raportit',
  pts: 'PTS',
  jarjestelmakuvaus: 'Järjestelmäkuvaus',
  energiakatselmus: 'Energia',
  kuvat: 'Kuvat',
};

function Taloyhtiokortti() {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl    = searchParams.get('tab')    || 'perustiedot';
  const subtabFromUrl = searchParams.get('subtab') || 'julkisivut';
  const [activeKey, setActiveKey] = useState(tabFromUrl);
  const [jarjestelmäSubtab, setJarjestelmäSubtab] = useState(subtabFromUrl);

  const { rakennusData: card, setRakennusData, mapCoords,loading, error } = useRakennusData();
  useEnsureEnergiaTable(id);
  const { availableImages, fetchSasUrlWithCache, loadImages } = useImageHandler(id);


  useEffect(() => {
    if (!card) return;
    recordVisit({
      id_kiinteisto: card.id_kiinteisto,
      kiinteistotunnus: card.kiinteistotunnus,
      kohteen_nimi: card.kohteen_nimi,
      osoite: card.rakennukset_fulls?.[0]?.osoite,
      postinumero: card.rakennukset_fulls?.[0]?.postinumero,
      toimipaikka: card.rakennukset_fulls?.[0]?.toimipaikka,
    });
  }, [card?.id_kiinteisto]);

  useEffect(() => {
    if (!card) return; // wait until card is loaded

    // Prefetch all images for this property in background
    const prefetchImages = async () => {
      try {
        // force load images from API/cache
        await loadImages(false); // false = don't force UI reload

        availableImages.forEach(img => {
          fetchSasUrlWithCache(img, false); // fetch each image, don't overwrite if cached
        });
      } catch (err) {
        console.error('Error prefetching images:', err);
      }
    };

    prefetchImages();
  }, [card]); // runs once when card data is available


  // Sync tabs if URL changes
  useEffect(() => { setActiveKey(tabFromUrl); }, [tabFromUrl]);
  useEffect(() => { setJarjestelmäSubtab(subtabFromUrl); }, [subtabFromUrl]);

  useDocumentTitle(
    card
      ? `${card.rakennukset_fulls?.[0]?.osoite || card.kohteen_nimi || 'Kiinteistökortti'} – ${TAB_LABELS[activeKey] || ''}`
      : undefined
  );

  if (!card) return <div className="text-center mt-5">Ladataan tietoja...</div>;

  const rakennus = card.rakennukset_fulls[0];

  

  return (

    <div className="main-content">
      <div className="text-white d-flex align-items-center justify-content-center shadow-sm py-2"
        style={{ background: 'linear-gradient(180deg, #1aa64a, #027000)' }}>
        <header className="text-center px-2">
          <h1 className="fw-bold mb-0" style={{ fontSize: 'clamp(1rem, 3.5vw, 1.75rem)' }}>
            {card?.kohteen_nimi}
          </h1>
          <p className="fw-light mb-1" style={{ fontSize: 'clamp(0.8rem, 2.5vw, 1.25rem)' }}>
            {rakennus?.osoite} {rakennus?.toimipaikka}
          </p>
          <hr className="border-white opacity-100 my-1" />
          <p className="fw-light mb-1" style={{ fontSize: 'clamp(0.75rem, 2vw, 1rem)' }}>Kiinteistön tiedot</p>

          <div className="d-flex justify-content-center mt-1 mb-1">
            <Tabs
              activeKey={activeKey}
              onSelect={(k) => setSearchParams(k === 'jarjestelmakuvaus' ? { tab: k, subtab: jarjestelmäSubtab } : { tab: k })}
              id="taloyhtiokortti-tabs"
              className="mb-0 custom-tabs taloyhtio-tabs justify-content-center"
              variant="pills"
            >
              <Tab eventKey="perustiedot" title={<span className="text-white">Perustiedot</span>} />
              <Tab eventKey="raportit" title={<span className="text-white">Raportit</span>} />
              <Tab eventKey="pts" title={<span className="text-white">PTS</span>} />
              <Tab eventKey="jarjestelmakuvaus" title={<span className="text-white">Järjestelmäkuvaus</span>} />
              <Tab eventKey="energiakatselmus" title={<span className="text-white">Energia</span>} />
              <Tab eventKey="kuvat" title={<span className="text-white">Kuvat</span>} />
              

            </Tabs>
          </div>
        </header>
      </div>

      {/* Tab content */}
      <div className="mt-1">
        {activeKey === 'perustiedot' && <PerustiedotTab card={card} setCard={setRakennusData} />}
        {activeKey === 'raportit' && <DokumentitTab kiinteisto={card} />}
        {activeKey === 'pts' && (
          <div>
            <div className="px-2 px-md-4">
              <CapexYhteenveto />
              <ToimenpiteetTekstimuodossa />
            </div>
            <PTSRoadmap />
            <PTSLongTermTable/>
          </div>
        )}
        {activeKey === 'jarjestelmakuvaus' && (
          <div>
            <div className="d-flex justify-content-center mt-1 mb-1">
              <Tabs
                activeKey={jarjestelmäSubtab}
                onSelect={(k) => setSearchParams({ tab: 'jarjestelmakuvaus', subtab: k })}
                id="jarjestelmakuvaus-subtabs"
                className="mb-0 custom-tabs2 justify-content-center"
                variant="pills"
              >
                <Tab eventKey="julkisivut" title={<span className="text-white">Julkisivut</span>} />
                <Tab eventKey="kuvaus"           title={<span className="text-white">Järjestelmäkuvaus</span>} />
                <Tab eventKey="kayttoiat"        title={<span className="text-white">Käyttöiät ja kunnossapito</span>} />
                <Tab eventKey="tarkastukset"     title={<span className="text-white">Määräaikaistarkastukset</span>} />
                <Tab eventKey="rakennusluvat"     title={<span className="text-white">Rakennusluvat</span>} />
              </Tabs>
            </div>
            <div className="mt-1">
              {jarjestelmäSubtab === 'kuvaus'      && <KiinteistoRiskEditor kiinteistoId={id} />}
              {jarjestelmäSubtab === 'julkisivut' && <KuntotutkimuksetTab card={card} />}
              {jarjestelmäSubtab === 'kayttoiat'  && <RTKayttoikaKysely kiinteistoId={id} rakennuksenIka={rakennus?.rakennusvuosi ? new Date().getFullYear() - rakennus.rakennusvuosi : null} />}
              {jarjestelmäSubtab === 'tarkastukset' && (
                <div className="px-2 px-md-4">
                  <MaaraaikaistarkastusTaulukko key={id} />
                </div>
              )}
              {jarjestelmäSubtab === 'rakennusluvat' && (
                <div className="px-2 px-md-4">
                  <RakennuslupaTaulukko key={id} />
                </div>
              )}
            </div>
          </div>
        )}
        {activeKey === 'energiakatselmus' && (
          <EnergiaKatselmusTab kiinteistoId={id} />
        )}
        {activeKey === 'kuvat' && (
            <div className="bg-white shadow-sm">
              <KiinteistoGallery propertyId={id} />
            </div>
          )}
      </div>
    </div>
  );
}

export default Taloyhtiokortti;
